import Microsoftoffice from '../../components/microsoftoffice/microsoftoffice';

const MicrosoftofficePage = () => {
  return <Microsoftoffice />;
};

export default MicrosoftofficePage;
